import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogContent, Box, Typography } from '@mui/material';
import { FiAlertTriangle } from 'react-icons/fi';
import Btn from 'components/button';
import { commonStyles as style } from 'assets/style';
import ProvisioningStyles from 'pages/provisioning/vm/style';

const BudgetCodeValidationModal = ({ open = false, budgetCode = '', onContinue = () => {}, onCancel = () => {}, title = 'Are you sure?' }) => {
    return (
        <Dialog
            open={open}
            onClose={(_, reason) => {
                if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') onCancel();
            }}
            aria-labelledby="budget-code-dialog-title"
            aria-describedby="budget-code-dialog-description"
            PaperProps={{ sx: { minWidth: '520px', minHeight: '340px' } }}
        >
            <DialogContent sx={style.modalWrapper}>
                <Box sx={ProvisioningStyles.confirmDD.dialogContentBox}>
                    <FiAlertTriangle color="#F99C24" size={70} />
                    <Typography sx={style.modalTitle} variant="span">
                        {title}
                    </Typography>
                    <div style={{ ...style.modalContent, marginTop: '12px', textAlign: 'center' }}>
                        <div>
                            We are unable to locate the cost center
                            {budgetCode && <strong style={{ fontFamily: 'monospace', marginLeft: '4px', marginRight: '4px' }}>{budgetCode}</strong>}
                            you provided in our system. Kindly confirm the correct cost center for cross-charge processing.
                        </div>
                    </div>
                </Box>
                <Box sx={ProvisioningStyles.confirmDD.dialogActionBox}>
                    <Btn
                        variant="contained"
                        onClick={onContinue}
                        className="uppercase tracking-wider text-sm custom-btn"
                        color="cmpPrimary"
                        sx={{ textTransform: 'none' }}
                        data-testid="budget-code-yes-btn"
                    >
                        Confirm
                    </Btn>
                    <Btn
                        variant="outlined"
                        color="cmpWarning"
                        sx={ProvisioningStyles.confirmDD.dialogNoBtn}
                        onClick={onCancel}
                        layout="outline"
                        className="uppercase tracking-wider text-sm custom-btn"
                        data-testid="budget-code-no-btn"
                    >
                        Cancel
                    </Btn>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

BudgetCodeValidationModal.propTypes = {
    open: PropTypes.bool,
    budgetCode: PropTypes.string,
    onContinue: PropTypes.func,
    onCancel: PropTypes.func,
    title: PropTypes.string,
};

BudgetCodeValidationModal.defaultProps = {
    open: false,
    budgetCode: '',
    onContinue: () => {},
    onCancel: () => {},
    title: 'Are you sure?',
};

export default React.memo(BudgetCodeValidationModal);
